import styled from 'styled-components'

/**
 * Moldura do preview. O iframe herda 100% daqui — a altura fixa é necessária
 * porque conteúdo de iframe não empurra o container pai.
 */
export const PreviewFrame = styled.div`
  border: 1px solid #e2e5e8;
  border-radius: 0.3rem;
  height: 70vh;
  background: #fff;

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
`

/** Estados de carregando / vazio, centralizados dentro da moldura. */
export const FrameState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #5e6ea7;
`

/** Linha dos botões de ação (editar / salvar / descartar / recarregar). */
export const ActionsWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`

/** Etiquetas de template e de "minuta editada", alinhadas à direita. */
export const BadgesWrapper = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  align-items: center;

  @media screen and (max-width: 767px) {
    justify-content: flex-start;
    margin-top: 10px;
  }
`
